import { signout as logoutExpertUser } from 'api/v3/access/accountantsAuth';
import { logout as logoutWebUser } from 'api/v2/users/authentication';
import { isWeb } from 'utils/constants';
import { getIntercom } from 'hooks/intercom.hook';
import { overrideAmplDefaultProps, setAmplitudeUser } from 'utils/amplitude';
import { getStoredExpertAuthData } from 'utils/expertAuth';
import pusherChannelController from 'utils/pusher';
import expertPusherChannelController from 'utils/pusher/expert';
import { clearStoredWorkspaceId } from 'utils/workspaceStorage';

const removeIntercomData = () => {
  getIntercom().shutdown();
};

// Returns any because it always reloads the page, so in effect, it never returns
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const logout = (skipCallback = false): any =>
  new Promise(() => {
    const expertAuthData = getStoredExpertAuthData();
    const clientId = isWeb
      ? localStorage.getItem('clientId')
      : expertAuthData?.auth?.clientId;
    const logoutAPI = isWeb ? logoutWebUser : logoutExpertUser;

    (skipCallback || !clientId
      ? Promise.resolve()
      : logoutAPI(clientId)
    ).finally(() => {
      setAmplitudeUser(null!);
      overrideAmplDefaultProps({}, true);
      // Invalidate and remove the user data from the query state on logout
      localStorage.removeItem('auth');
      clearStoredWorkspaceId();
      removeIntercomData();
      expertPusherChannelController.destroy();
      pusherChannelController.destroy();
      window.location.href = '/';
      // appQueryClient.removeQueries(); // test
      // zustandCleanup.cleanup(); // test
    });
  });

export default logout;
